import React, { useState } from "react";
import { API_BASE } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const todayCL = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Santiago" });

const fechaLarga = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  const mes = new Date(y, m - 1, d).toLocaleDateString("es-CL", { month: "long" });
  return `${d} ${mes.charAt(0).toUpperCase()}${mes.slice(1)} ${y}`;
};

export default function PostReportDialog({ open, onOpenChange }) {
  const [date, setDate] = useState(todayCL());
  const [all, setAll] = useState(false);
  const [busy, setBusy] = useState(false);

  const download = async () => {
    if (!all && !date) { toast.error("Elige una fecha."); return; }
    setBusy(true);
    try {
      const token = localStorage.getItem("eim_token");
      const resp = await fetch(`${API_BASE}/admin/report/post-pdf${all ? "" : `?date=${date}`}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!resp.ok) throw new Error();
      const url = URL.createObjectURL(await resp.blob());
      const name = `reporte_post_reunion_becas ${all ? "todas las fechas" : fechaLarga(date)}.pdf`;
      const a = document.createElement("a"); a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
      onOpenChange(false);
    } catch { toast.error("No se pudo generar el reporte."); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="post-report-dialog">
        <DialogHeader>
          <DialogTitle>Reporte post reunión</DialogTitle>
          <DialogDescription>Incluye las decisiones registradas por el comité: aprobadas, % distinto, rechazadas y casos a los que se pidió información.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs font-semibold uppercase text-slate-500">Fecha de la reunión</Label>
            <Input type="date" className="h-11 rounded-xl mt-1.5" value={date} disabled={all} onChange={(e) => setDate(e.target.value)} data-testid="post-report-date" />
          </div>
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={all} onCheckedChange={(v) => setAll(!!v)} data-testid="post-report-all" /> Todas las decisiones, de cualquier fecha
          </label>
        </div>
        <DialogFooter>
          <Button onClick={download} disabled={busy} className="rounded-xl" data-testid="post-report-download">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Descargar PDF"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
